import {
  PostGuideCategoryInterface,
  DeleteGuideCategoryInterface,
  UpdateGuideCategoryInterface,
} from '@/data/payload/contracts/GuideCategoryRequest'

export class UpdateGuideCategoryRequest
  implements UpdateGuideCategoryInterface {
  private name: string
  private isActive: boolean
  private imageCoverId: number
  private imageThumbnailId: number
  private imageLogoId: number
  private tag: string

  constructor(
    name: string,
    isActive: boolean,
    imageCoverId: number,
    imageThumbnailId: number,
    imageLogoId: number,
    tag: string
  ) {
    this.name = name
    this.isActive = isActive
    this.imageCoverId = imageCoverId
    this.imageThumbnailId = imageThumbnailId
    this.imageLogoId = imageLogoId
    this.tag = tag
  }
  public toJSON() {
    const data = {
      name: this.name,
      is_active: this.isActive,
      image_cover_id: this.imageCoverId,
      image_thumbnail_id: this.imageThumbnailId,
      image_logo_id: this.imageLogoId,
      tag: this.tag,
    }
    return JSON.stringify({
      data,
    })
  }
}
export class DeleteGuideCategoryRequest
  implements DeleteGuideCategoryInterface {
  private ids: number

  constructor(ids: any) {
    this.ids = ids
  }
  public toJSON() {
    const Ids = this.ids
    return JSON.stringify({
      Ids,
    })
  }
}

export class GuideCategoryApiRequest implements PostGuideCategoryInterface {
  private name: string
  private isActive: boolean
  private imageCoverId: number
  private imageThumbnailId: number
  private imageLogoId: number
  private tag: string

  constructor(
    name: string,
    isActive: boolean,
    imageCoverId: number,
    imageThumbnailId: number,
    imageLogoId: number,
    tag: string
  ) {
    this.name = name
    this.isActive = isActive
    this.imageCoverId = imageCoverId
    this.imageThumbnailId = imageThumbnailId
    this.imageLogoId = imageLogoId
    this.tag = tag
  }

  public toJSON() {
    const data = {
      name: this.name,
      is_active: this.isActive,
      image_cover_id: this.imageCoverId,
      image_thumbnail_id: this.imageThumbnailId,
      image_logo_id: this.imageLogoId,
      tag: this.tag,
    }

    return JSON.stringify({
      data,
    })
  }
}
